// src/components/LatLonInputs.js

import React from "react";

export function LatLonInputs({
  lat,
  lon,
  onChange,
  disabled,
  errors,
  baseInputStyle,
  disabledInputStyle,
}) {
  const handleLatChange = (value) => {
    if (disabled) return;
    // just store raw string
    onChange(value, lon);
  };

  const handleLonChange = (value) => {
    if (disabled) return;
    // just store raw string
    onChange(lat, value);
  };

  const labelStyle = { fontSize: 13, display: "block", marginBottom: 6 };

  const effectiveLatStyle = disabled ? disabledInputStyle : baseInputStyle;
  const effectiveLonStyle = disabled ? disabledInputStyle : baseInputStyle;

  return (
    <div style={{ marginTop: 4 }}>
      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}
      >
        <div>
          <label style={labelStyle}>
            Latitude:
            <input
              placeholder="26.2389"
              value={lat || ""} // always a string
              onChange={(e) => handleLatChange(e.target.value)}
              style={effectiveLatStyle}
              inputMode="decimal"
              disabled={disabled}
            />
          </label>
          {errors && errors.lat && (
            <div style={{ fontSize: 11, color: "#f97373", marginTop: 2 }}>
              {errors.lat}
            </div>
          )}
        </div>

        <div>
          <label style={labelStyle}>
            Longitude:
            <input
              placeholder="73.0243"
              value={lon || ""} // always a string
              onChange={(e) => handleLonChange(e.target.value)}
              style={effectiveLonStyle}
              inputMode="decimal"
              disabled={disabled}
            />
          </label>
          {errors && errors.lon && (
            <div style={{ fontSize: 11, color: "#f97373", marginTop: 2 }}>
              {errors.lon}
            </div>
          )}
        </div>
      </div>

      <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>
        {disabled
          ? "Latitude / longitude are auto-filled from city geocoding."
          : "Enter coordinates manually. City & country inputs are disabled in this mode."}
      </div>
    </div>
  );
}
